import { ReactElement } from "react";
import PageNotFoundView from "views/page-not-found";

const PageNotFound = (): ReactElement => {
  return <PageNotFoundView />;
};

export default PageNotFound;
